// packages/i18n/src/shared/utils/fillParams.ts

/**
 * The `:param` names in a path pattern, as a literal union —
 * `'/users/:userId/orders/:orderId'` gives `'userId' | 'orderId'`, a pattern with none gives
 * `never`. The type-level twin of the regex below, so a URL helper can demand exactly the
 * replacements its pattern will look up.
 */
export type ColonParams<P extends string> = P extends `${string}:${infer K}/${infer R}`
  ? K | ColonParams<`/${R}`>
  : P extends `${string}:${infer K}`
    ? K
    : never;

/** Fills in parameters in a URL pattern.
 * E.g. "/users/:userId/orders/:orderId" with { userId: 5, orderId: 10 }
 * becomes "/users/5/orders/10"
 */
export const fillParams = (
  pattern: string,
  params?: Readonly<Record<string, string | number>>
) => {
  if (!params) return pattern;
  return pattern.replace(/:([A-Za-z0-9_]+)/g, (_match: string, key: string) => {
    const v = params[key];
    if (v == null) {
      throw new Error(`Missing param :${key} for pattern "${pattern}"`);
    }
    return String(v);
  });
};
